export const STUDENT = 'STUDENT';
export const TEACHER = 'TEACHER';
export const SCHOOL_ADMIN = 'SCHOOL_ADMIN';
export const DISTRICT_OWNER = 'DISTRICT_OWNER';
export const TWIGADMIN = 'TWIGADMIN';
export const SUPERUSER = 'SUPERUSER';
